import { Button } from 'antd';

type AxisConfigurationModalFooterProps = {
    hasApplyChanges: boolean;
    hasResetChanges: boolean;
    onReset: () => void;
    onCancel: () => void;
    onApply: () => void;
};

const AxisConfigurationModalFooter = ({
    hasApplyChanges,
    hasResetChanges,
    onReset,
    onCancel,
    onApply,
}: AxisConfigurationModalFooterProps) => (
    <div className="flex items-center justify-between">
        <Button
            type="link"
            className="!h-8 !p-0 !font-normal !text-blackAlt hover:!text-blackAlt disabled:!text-fontGreyAlt1"
            onClick={onReset}
            disabled={!hasResetChanges}
        >
            Reset
        </Button>
        <div className="flex items-center gap-2">
            <Button className="!h-8 !rounded-lg !border-borderGreyAl1 !font-semibold" onClick={onCancel}>
                Cancel
            </Button>
            <Button
                type="primary"
                className="axis-apply-btn !h-8 !rounded-lg !font-normal"
                onClick={onApply}
                disabled={!hasApplyChanges}
            >
                Apply
            </Button>
        </div>
    </div>
);

export default AxisConfigurationModalFooter;
